<template>
  <div class="help-element">
    <div v-show="view === 'search'">
      <div class="search-help container">
        <div class="search-help__container container mb-4">
          <img
            class="help-element--logo"
            src="https://www.uptodatewebdesign.be/wp-content/uploads/avatar-utd.png"
          />
          <h2>Hoe kunnen we u helpen?</h2>
          <div class="search-help__main search-main-container search-main-container">
            <Autocomplete
              class="autocomplete-container"
              :get-result-value="getResultValue"
              :search="search"
              placeholder="Zoek helpcentrum"
              @submit="handleSubmit"
            >
              <template #result="{ result, props }">
                <li v-bind="props" class="Autocomplete-result">
                  <div class="autocomplete-result-item">
                    {{ result.title }}
                  </div>
                </li>
              </template>
            </Autocomplete>
            <button
              id="iv4rlg"
              class="search-btn btn-primary button button-blue text-bold text-uppercase"
              @click="handleSubmit"
            >
              ZOEKEN
            </button>
          </div>
        </div>

        <div v-if="!bloggerPostLoaded">
          <div class="text-center">
            <div class="w-100 loader-container">
              <h2>Laden...</h2>
            </div>
          </div>
        </div>
        <div v-else class="search-help__label-container mt-5">
          <span
            v-for="label in Object.keys(labels.count)"
            class="search-help__label"
            @click="searchByLabel(label)"
            >{{ label }} <small>({{ labels.count[label] }})</small></span
          >
        </div>

        <div class="help-element--container">
          <div
            v-for="element in categories"
            class="help-element--item"
            @click="searchByLabel(element.label)"
          >
            <div class="help-element--item-inner">
              <img class="help-element--item-img" :src="element.icon" />
              <h4 class="help-element--item-name">{{ element.label }}</h4>
            </div>
          </div>
        </div>
        <!-- <hr class="mt-5 mb-5" />

        <div class="row help-element--container mt-4 text-left">
          <div v-for="(postItem, index) in randomPosts" :key="index" class="">
            <div class="card-border card" style="height: 100%">
              <div class="post-item-list-header-container">
                <div
                  class="post-item-list-header with-overlay cursor"
                  :style="`background-image: url(${
                    postItem.post[0].image || defaultImage
                  }),linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5))`"
                  @click="searchByLabel(postItem.label)"
                ></div>
                <div class="post-item-list-title">
                  <h5 class="cursor" @click="searchByLabel(postItem.label)">
                    {{ postItem.label }}
                  </h5>
                </div>
              </div>
              <div class="card-body mw-90 p-5">
                <ul>
                  <li
                    v-for="blog in postItem.post.slice(0, 4)"
                    style="list-style: number"
                    class="cursor post-item-list"
                    @click="viewDetailsAndShowLabel(blog, postItem.label)"
                  >
                    <div>
                      <div>
                        <p class="mb-1">
                          {{ blog.title }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
                <p
                  v-if="postItem.post.length - 5 > 0"
                  class="cursor"
                  style="color: #2a99d6"
                  @click="searchByLabel(postItem.label)"
                >
                  and {{ postItem.post.length - 5 }} more...
                </p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div v-if="bloggerPostLoaded && view === 'label-list'" class="container search-help">
      <div class="row">
        <div class="col-md-12">
          <div style="position: sticky; top: 100px">
            <span
              class="d-block cursor text-left go-back-btn-search"
              @click="goBack('search')"
            >
              <i class="fa fa-arrow-left"></i> Ga terug
            </span>
            <Autocomplete
              class="autocomplete-container mb-5"
              :get-result-value="getResultValue"
              :search="search"
              placeholder="Zoek helpcentrum"
              @submit="handleSubmit"
            >
              <template #result="{ result, props }">
                <li v-bind="props" class="Autocomplete-result">
                  <div class="autocomplete-result-item">
                    {{ result.title }}
                  </div>
                </li>
              </template>
            </Autocomplete>
            <div class="site-preview__list mh-scroll-700">
              <h3>
                Resultaten weergeven:
                <span class="text-underline">{{ labelSearchKeyword }}</span>
              </h3>
              <hr />
              <ul class="post-item-list post-item-list-big">
                <li
                  v-for="blog in labels.posts[labelSearchKeyword]"
                  class="cursor"
                  @click="viewDetails(blog, 'preview')"
                >
                  <div class="post-item-list-container">
                    <div>
                      <img :src="blog.image" />
                    </div>
                    <div>
                      <h4>{{ blog.title }}</h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="bloggerPostLoaded && view === 'preview'"
      class="article-container search-help"
    >
      <div class="row">
        <div class="col-md-8">
          <span class="cursor text-left go-back-btn" @click="goBack('search')">
            <i class="fa fa-arrow-left"></i> Ga terug
          </span>
          <div v-if="postToPreview.title" class="site-preview__container mh-scroll">
            <div>
              <div class="site-preview__content">
                <div class="b--spacer-md">
                  <h1 class="mb-3">{{ postToPreview.title }}</h1>
                  <div class="site-preview__labels">
                    <span
                      v-for="categ in postToPreview.labels"
                      @click="searchByLabel(categ.term)"
                      >{{ categ.term }}</span
                    >
                  </div>
                </div>
                <div v-html="postToPreview.content"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div style="position: sticky; top: 100px">
            <span
              class="d-block cursor text-left go-back-btn-search"
              @click="goBack('search')"
            >
              <i class="fa fa-arrow-left"></i> Ga terug
            </span>
            <Autocomplete
              class="autocomplete-container mb-5"
              :get-result-value="getResultValue"
              :search="search"
              placeholder="Zoek helpcentrum"
              @submit="handleSubmit"
            >
              <template #result="{ result, props }">
                <li v-bind="props" class="Autocomplete-result">
                  <div class="autocomplete-result-item">
                    {{ result.title }}
                  </div>
                </li>
              </template>
            </Autocomplete>
            <div class="site-preview__list mh-scroll-700">
              <h4>Gerelateerd artikel</h4>
              <hr />
              <ul class="post-item-list" v-if="labels.posts[labelSearchKeyword]">
                <li
                  v-for="blog in labels.posts[labelSearchKeyword]"
                  class="cursor"
                  @click="viewDetails(blog, 'preview')"
                >
                  <div class="post-item-list-container">
                    <div>
                      <img :src="blog.image" />
                    </div>
                    <div>
                      <h5>{{ blog.title }}</h5>
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="post-item-list" v-else>
                <li
                  v-for="blog in blogPosts"
                  class="cursor"
                  @click="viewDetails(blog, 'preview')"
                >
                  <div class="post-item-list-container">
                    <div>
                      <img :src="blog.image" />
                    </div>
                    <div>
                      <h5>{{ blog.title }}</h5>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/helpers/api.js";
import { imageGallery, getImageFromBlogPost } from "@/helpers/utils.js";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      labels: {
        count: {},
        lbl: [],
        posts: {},
      },
      categories: [
        {
          icon:
            "https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/sidebar-icons/v2/UTD-sitemap-2-icon.png",
          label: "sites",
        },
        {
          icon:
            "https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/static/svg/UTD-newsletter-1-icon.svg",
          label: "blog",
        },
        {
          icon:
            "https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/static/svg/UTD-news-2-icon.svg",
          label: "newsletter",
        },
        {
          icon:
            "https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/static/svg/UTD-sharing-2-icon.svg",
          label: "social",
        },
        {
          icon:
            "https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/static/svg/UTD-more-plus-1-icon.svg",
          label: "tools",
        },
      ],
      randomPosts: [],
      labelSearchKeyword: "",
      view: "search",
      comments: [],
      blogPosts: null,
      bloggerPostLoaded: false,
      postToPreview: {},
      defaultImage:
        "https://lh3.googleusercontent.com/-C8GvYsGjVLc/YI12_1R6wPI/AAAAAAAAAv4/HGW-dGRZnGQmPv76Rmc0B6UUsOowDXq0QCLcBGAsYHQ/s640/UTD-Example.png",
    };
  },
  created() {
    this.getBlogPosts();
  },
  methods: {
    goBack(type) {
      let query = Object.assign({}, this.$route.query);
      delete query.article;
      this.$router.replace({ query });
      this.view = type;
    },
    shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    getRandomThreeLabel() {
      let randomPosts = [];
      let selectedLabel = [];
      this.labels.lbl.forEach((label) => {
        selectedLabel.push(label);
        let fiveSelectedPosts = {
          label,
          post: this.labels.posts[label],
        };
        if (randomPosts.length < 4) {
          randomPosts.push(fiveSelectedPosts);
        }
      });
      this.randomPosts = this.shuffleArray(randomPosts);
    },
    handleSubmit(result) {
      if (result) {
        this.viewDetails(result, "preview");
      } else {
        this.viewDetails(result, "preview");
      }
    },
    getResultValue(result) {
      return result.title;
    },
    search(input) {
      return (
        this.blogPosts.filter((blogPostItem) => {
          return blogPostItem.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }) || []
      );
    },
    viewDetailsAndShowLabel(post, label) {
      this.searchByLabel(label);
      this.viewDetails(post, "preview");
    },
    viewDetails(blogPostContent, view) {
      this.view = view;
      this.postToPreview = blogPostContent;
      let query = Object.assign({}, this.$route.query);
      query.article = this.postToPreview.id;
      this.$router.replace({ query });

      this.renderSlider();
      setTimeout(() => {
        imageGallery(".site-preview__container a:has(img)");
      }, 500);
    },
    searchByLabel(label) {
      this.view = "label-list";
      this.postToPreview = {};
      this.labelSearchKeyword = label;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    getLabels(blogPostArr) {
      let lbl = [];
      let count = {};
      let posts = {};
      blogPostArr.forEach((item) => {
        if (item.labels) {
          item.labels.map((label) => {
            let l = label.term;
            if (!count[l]) {
              count[l] = 0;
              posts[l] = [];
            }
            count[l] += 1;
            posts[l].push(item);
            if (lbl.indexOf(l) == -1) {
              lbl.push(l);
            }
          });
        }
      });
      this.labels = {
        lbl,
        count,
        posts,
      };
    },
    async getBlogPosts() {
      if (!this.blogPosts) {
        this.blogPosts = [];
        api
          .post(`/blogger/proxy`, {
            url: `https://uptodate-support.blogspot.com/feeds/posts/default?alt=json&max-results=150`,
          })
          .then((post) => {
            if (post.data.feed) {
              let blogPostsObj = {};
              this.blogPosts = post.data.feed.entry.map((item) => {
                let postId = item.id.$t
                  ? item.id.$t.split(".")[2].split("post-")[1]
                  : " ";
                let img = getImageFromBlogPost(item.content.$t);
                let payload = {
                  id: item.id.$t ? item.id.$t.split(".")[2].split("post-")[1] : " ",
                  image: img,
                  link: item.link.filter((l) => l.rel == "alternate")[0].href,
                  title: item.title.$t,
                  content: item.content.$t,
                  labels: item.category || [],
                };
                blogPostsObj[postId] = payload;
                return payload;
              });

              this.getLabels(this.blogPosts);
              this.getRandomThreeLabel();
              this.bloggerPostLoaded = true;
              console.log("route:", this.$route.query.article);
              if (this.$route.query.article) {
                this.postToPreview = blogPostsObj[this.$route.query.article];
                this.view = "preview";
                setTimeout(() => {
                  this.renderSlider();
                  setTimeout(() => {
                    imageGallery(".site-preview__container a:has(img)");
                  }, 500);
                }, 500);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    renderSlider() {
      this.loadFotoramaAndInitialize();
    },

    loadFotoramaAndInitialize() {
      // First check if jQuery is available
      if (typeof $ === 'undefined') {
        console.log("jQuery not found, loading it...");
        this.loadScript('https://code.jquery.com/jquery-3.6.1.min.js', () => {
          this.loadFotoramaAndInitialize();
        });
        return;
      }

      // Check if Fotorama is available
      if (!$.fn.fotorama) {
        console.log("Fotorama not found, loading it...");
        // Load Fotorama CSS first
        this.loadCSS('https://cdnjs.cloudflare.com/ajax/libs/fotorama/4.6.4/fotorama.css');
        // Then load Fotorama JS
        this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/fotorama/4.6.4/fotorama.js', () => {
          this.initializeFotorama();
        });
      } else {
        this.initializeFotorama();
      }
    },

    loadScript(src, callback) {
      const script = document.createElement('script');
      script.src = src;
      script.onload = callback;
      script.onerror = () => {
        console.error("Failed to load script:", src);
      };
      document.head.appendChild(script);
    },

    loadCSS(href) {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    },

    initializeFotorama() {
      const checkFotoramaInterval = setInterval(() => {
        if (typeof $ !== 'undefined' && $.fn.fotorama) {
          clearInterval(checkFotoramaInterval);
          try {
            let fotorama = $(".fotorama");
            console.log("Found fotorama elements:", fotorama.length);
            if (fotorama.length > 0) {
              // Destroy existing fotorama instances first
              fotorama.each(function() {
                if ($(this).data('fotorama')) {
                  $(this).data('fotorama').destroy();
                }
              });
              
              // Initialize new fotorama
              $(".fotorama").fotorama({
                nav: 'thumbs',
                arrows: true,
                click: true,
                swipe: true,
                trackpad: true,
                keyboard: true,
                fit: 'cover',
                transition: 'slide'
              });
              console.log("Fotorama initialized successfully");
            }
          } catch (err) {
            console.log("Fotorama error: ", err);
          }
        } else {
          console.log("Waiting for Fotorama to be ready...", typeof $, typeof $.fn?.fotorama);
        }
      }, 200);
      
      // Clear interval after 10 seconds to prevent infinite checking
      setTimeout(() => {
        clearInterval(checkFotoramaInterval);
        console.log("Fotorama initialization timeout");
      }, 10000);
    },
  },
};
</script>
<style>
.help-element {
  margin-top: 50px;
  margin-bottom: 50px;
}

.help-element--logo {
  max-width: 100px;
  margin-bottom: 30px;
  display: inline-block;
}
.help-element .cursor {
  cursor: pointer;
}

.help-element--container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 1rem;
  max-width: 960px;
  margin: 0 auto;
  margin-top: 50px;
}

.help-element--item {
  border: 1px solid #eae9e9;
  box-shadow: 0 8px 60px 0 rgb(103 151 255 / 11%), 0 12px 90px 0 rgb(103 151 255 / 0%);
  border-radius: 10px;
  padding: 25px;
  cursor: pointer;
  transition: 0.2s;
}
.help-element--item:hover {
  box-shadow: 0 8px 60px 0 rgb(103 151 255 / 11%), 0 12px 90px 0 rgb(0 188 212 / 30%);
}

.help-element--item-img {
  max-width: 80px;
  display: inline-block;
}

.help-element--item-name {
}

.mh-scroll-700 {
  max-height: 70vh;
  overflow: auto;
  text-align: left;
}
.autocomplete-result-list {
  text-align: left;
}
.site-preview__list {
  background: white;
}

.site-preview__labels {
  margin-bottom: 20px;
}

.site-preview__labels span {
  display: inline-block;
  color: #aaa;
  cursor: pointer;
  margin-right: 5px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
  padding: 0 5px;
  border-radius: 5px;
  font-size: 12px;
}

.site-preview__content {
  max-width: 720px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  /* -webkit-box-shadow: 0 24px 24px -18px #000, 0 9px 45px 0 #000;
  box-shadow: 0 24px 24px -18px #000, 0 9px 45px 0 #000; */
  padding: 70px 50px;
  font-size: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #ccc;
  text-align: left;
}
.site-preview__content h1 {
  font-size: 32px;
}

.site-preview__content img {
  max-width: 100%;
}

.site-preview__container {
  /* background: #eef5fa; */
  /* border-radius: 100px;
	 */
  /* padding: 70px 60px; */
}

.search-main-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.autocomplete-container {
  width: 100%;
  max-width: 500px;
  margin-right: 20px;
  z-index: 10;
}

.search-btn {
  height: 50px;
  width: 150px;
}

.article-container {
  max-width: 1200px;
  margin: 0 auto;
}

.search-help__main {
  margin-bottom: 20px;
  text-align: left;
}

.search-help__container {
  background: url(https://ssl.gstatic.com/support/content/images/static/homepage_header_background_v2.svg);
  background-size: contain;
  background-repeat: no-repeat;
}

.search-help__label-container {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}

.search-help__label {
  display: inline-block;
  color: #aaa;
  cursor: pointer;
  margin-right: 5px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 12px;
}

.with-overlay:after {
  content: " ";
  width: 100%;
  height: 100%;
  background: linear-gradient(0, white, #ffffffa3, transparent);
  position: absolute;
  bottom: 0;
}

.post-item-list {
  list-style: none;
  margin-left: 0;
}

.post-item-list-container {
  display: flex;
  align-items: center;
}

.post-item-list-container h5,
.post-item-list-container h4 {
  cursor: pointer;
}

.post-item-list-header {
  height: 120px;
  background-size: cover;
  background-position: center;
}

.post-item-list-header-container {
  position: relative;
}

.post-item-list-title {
  bottom: 0px;
  position: absolute;
  z-index: 2;
  width: 100%;
  left: 0;
}

.post-item-list-title h5 {
  font-weight: bold;
  border-bottom: 1px solid;
  cursor: pointer;
  padding: 15px;
}

.post-item-list h5:hover,
.post-item-list h4:hover,
.post-item-list p:hover {
  color: #2a99d6;
}

.post-item-list img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  min-width: 50px;
  border-radius: 5px;
  margin-right: 15px;
  margin-bottom: 15px;
}
.post-item-list-big img {
  width: 80px;
  height: 80px;
}
.go-back-btn-search,
.go-back-btn {
  margin-bottom: 20px;
}
.go-back-btn {
  display: none;
}

@media screen and (max-width: 768px) {
  .search-help {
    padding: 20px;
  }
  .help-element--container {
    grid-template-columns: 1fr 1fr;
  }
  .site-preview__content {
    padding: 0;
    border: unset;
  }
  .col-md-4 {
    margin-top: 32px;
  }
  .search-help__main {
    flex-direction: column;
  }
  .search-main-container .autocomplete-container {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .go-back-btn {
    display: block;
  }
}
</style>
